import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './Register.css';

const Register = () => {
  const { register, error, currentUser } = useContext(AuthContext);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [password, setPassword] = useState('');
  const [formData, setFormData] = useState({
    education: false,
    harvesting: false,
    communityOutreach: false,
    council: false,
    hr: false,
    communityResources: false,
    consultation: false
  });
  const userType = 'user'; // Hardcoded to user type
  const [isLoading, setIsLoading] = useState(false);
  const [showCardHelp, setShowCardHelp] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    const success = await register({ 
      firstName, 
      lastName, 
      email, 
      cardNumber, 
      password, 
      userType, // This will always be 'user' now
      ...formData // Include formData in the registration
    });
    
    setIsLoading(false);
    
    if (success) {
      navigate('/dashboard');
    }
  };

  return (
    <div className="register-container">
      <h2>Register</h2>
      
      {error && <p className="error-message">{error}</p>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="firstName">First Name</label>
          <input
            type="text"
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName">Last Name</label>
          <input
            type="text"
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email (Username)</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <div className="field-label-row">
            <label htmlFor="cardNumber">RSMIN Card Number</label>
            <button
              type="button"
              className="card-help-trigger"
              onClick={() => setShowCardHelp(true)}
            >
              Where is this number?
            </button>
          </div>
          <input
            type="text"
            id="cardNumber"
            value={cardNumber}
            onChange={(e) => setCardNumber(e.target.value)}
            required
          />
          <small className="card-help-hint">Use the number shown in the blue highlighted box on your citizen card.</small>
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        
        {/* Access Type Permissions Section - Only visible to admins */}
        {currentUser?.userType === 'admin' && (
          <div className="form-section">
            <h3>Access Permissions</h3>
            <div className="permissions-grid">
              <label className="permission-checkbox">
                <input
                  type="checkbox"
                  name="education"
                  checked={formData.education}
                  onChange={(e) => setFormData({ ...formData, education: e.target.checked })}
                />
                <span>Education Access</span>
              </label>
              
              <label className="permission-checkbox">
                <input
                  type="checkbox"
                  name="harvesting"
                  checked={formData.harvesting}
                  onChange={(e) => setFormData({ ...formData, harvesting: e.target.checked })}
                />
                <span>Harvesting Access</span>
              </label>
              
              <label className="permission-checkbox">
                <input
                  type="checkbox"
                  name="communityOutreach"
                  checked={formData.communityOutreach}
                  onChange={(e) => setFormData({ ...formData, communityOutreach: e.target.checked })}
                />
                <span>Community Outreach Access</span>
              </label>
              
              <label className="permission-checkbox">
                <input
                  type="checkbox"
                  name="council"
                  checked={formData.council}
                  onChange={(e) => setFormData({ ...formData, council: e.target.checked })}
                />
                <span>Council</span>
              </label>
              
              <label className="permission-checkbox">
                <input
                  type="checkbox"
                  name="hr"
                  checked={formData.hr}
                  onChange={(e) => setFormData({ ...formData, hr: e.target.checked })}
                />
                <span>HR</span>
              </label>
              
              <label className="permission-checkbox">
                <input
                  type="checkbox"
                  name="communityResources"
                  checked={formData.communityResources}
                  onChange={(e) => setFormData({ ...formData, communityResources: e.target.checked })}
                />
                <span>Community Resources</span>
              </label>

              <label className="permission-checkbox">
                <input
                  type="checkbox"
                  name="consultation"
                  checked={formData.consultation}
                  onChange={(e) => setFormData({ ...formData, consultation: e.target.checked })}
                />
                <span>Consultation</span>
              </label>
            </div>
          </div>
        )}

        <button type="submit" disabled={isLoading}>
          {isLoading ? 'Registering...' : 'Register'}
        </button>
      </form>

      {showCardHelp && (
        <div className="card-help-modal-overlay" onClick={() => setShowCardHelp(false)}>
          <div className="card-help-modal" onClick={(e) => e.stopPropagation()}>
            <div className="card-help-header">
              <h3>Citizen Card Number Help</h3>
              <button type="button" className="card-help-close" onClick={() => setShowCardHelp(false)}>&times;</button>
            </div>
            <p className="card-help-copy">Enter the card number located in the blue highlighted box on your card.</p>
            <img src="/card.jpg" alt="Citizen card sample showing where to find the card number" className="card-help-image" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Register;